module.exports = __webpack_public_path__ + "static/media/quote.58c2887b.svg";